//nome = codigo no BD
export const enum EStatusOrdemCompra {
  'AguardandoDefinicaoComprador' = 1,
  'AguardandoAnaliseComprador' = 2,
  'AguardandoEnvioCartasConvite' = 3, //506c35e5-291a-4866-8e50-6b03ff6ef227
  'AguardandoEsclarecimentoTecnicos' = 4,
  'AguardandoEnvioPropostaTecnica' = 5,
  'AguardandoAnaliseTecnica' = 6,
  'AguardandoValidacao' = 7,
  'AguardandoEnvioPropostaComercial' = 8,
  'AguardandoAnaliseComercial' = 9,
  'AguardandoAprovacaoBoD' = 10,
  'AguardandoAprovacaoAssinatura' = 11,
  'Concluido' = 12,
  'Cancelada' = 13,
  'AguardandoExpectativaCompras' = 14,
  'OnHoldAguardandoRequisitante' = 15,
  'AguardandoAnaliseDocumentacao' = 16
}

export const enum EStatusOrdemCompraExibicao {
  'AguardandoDefinicaoDoComprador' = 1,
  'EnvioCartaConvite' = 2,
  'EsclarecimentosTecnicos' = 3,
  'EnvioPropostaTecnica' = 4,
  'AnaliseTecnica' = 5,
  'EnvioPropostaComercial' = 6,
  'NegociacaoComercial' = 7,
  'NegociacaoMinutaContratual' = 8,
  'AprovacaoEAssinaturaDocumentos' = 9,
  'HomologacaoProcessoContratacao' = 10,
  'EnvioComunicacaoContratada' = 11,
  'Concluido' = 12,
  'Cancelada' = 13,
  'OnHoldAguardandoRequisitante' = 14,
}